import { StatusFilter } from 'domain/shared/newProject';
import { POSITION_SLOT_STATUS_LABELS } from '../constants';

const PositionSlotStatusFilter = ({ source, label }: { source: string; label: string }) => {
  return <StatusFilter source={source} label={label} options={POSITION_SLOT_STATUS_LABELS} />;
};

export default PositionSlotStatusFilter;
